enum LinkType {
    unknown = 0,
    youtube = 1,
    vimeo = 2
}

export default LinkType;